export default {
  LIST: {
    TITLE: `Contact lists`,
    SUMMARY: ``
  },
  VIEW: {
    TITLE: `Contact List`,
    SUMMARY: ``
  },
  STATUSES: {
    PAUSED: `Paused`,
    CREATING: `Creating`,
    PENDING: `Pending`,
    RUNNING: `Running`,
    CREATED: `Created`,
    ARCHIVED: `Archived`
  },
  CONTACT_USER_HISTORY_MODAL: {
    TITLE: `User History for {{ name }}`,
    SUMMARY: ``
  },
  CONTACT_USERS_HISTORY_MODAL: {
    TITLE: `Users contact history`,
    SUMMARY: ``,
    SEEING_THESE_USERS: `You are seeing the contact history for {{ count }} users :`,
    LOADING_DATA: `Loading the history`
  },
  CONTACT_LIST_HISTORY_MODAL: {
    TITLE: `List History`,
    SUMMARY: ``
  },
  CONTACT_USER_PRIORITY_MODAL: {
    TITLE: `Change priority for {{ name }}`,
    SUMMARY: ``,
    PRIORITY: {
      LABEL: `New priority`,
      PLACEHOLDER: `Enter a priority number`,
      DESCRIPTION: `Used to re-order users in a contact list, entering a new priority number will place the user before the user who had that priority before.`
    }
  },
  CONTACT_USER_HOURS_OFFERED_MODAL: {
    TITLE: `Change number of hours offered to {{ name }}`,
    SUMMARY: ``,
    NUMBEROFHOURSOFFERED: {
      LABEL: `Number of hours offered`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Used to adjust the number of hours offered to a user. This number can be negative to adjust the total of hours offered.`
    }
  },
  CONTACT_USER_TIMES_CONTACTED_MODAL: {
    TITLE: `Change number of times contacted for {{ name }}`,
    SUMMARY: ``,
    NUMBEROFTIMESCONTACTED: {
      LABEL: `Number of times contacted`,
      PLACEHOLDER: `Enter a number`,
      DESCRIPTION: `Used to adjust the number of times contacted. Use this field when you have contacted a user without using the system.`
    }
  },
  CONTACT_USER_SHIFT_ELIGIBILITY_MODAL: {
    TITLE: `View eligibility for {{ name }}`,
    SUMMARY: `This modal allows you to edit user eligibility for shifts in a contact list.`,
    ELIGIBLE: `Eligible`,
    ELIGIBLE_FORCED_BY: `Eligible, forced by {{ forcedBy }}`,
    NOT_ELIGIBLE: `Not eligible`,
    NOT_ELIGIBLE_FORCED_BY: `Not eligible, forced by {{ forcedBy }}`,
    MAKE_NOT_ELIGIBLE: `Make not eligible`,
    MAKE_ELIGIBLE: `Make eligible`,
    ERROR_SAVING_ELIGIBILITY: `Error saving eligibility`
  },
  CONTACT_USER_ADD_HISTORY_MODAL: {
    TITLE: `Add history event for {{ name }}`,
    SUMMARY: ``,
    ERROR_SAVING_ENTRY: `There was an error saving history event`,
    PLEASE_SELECT_SHIFT: `Please select a shift for the user to accept.`,
    CONTACT_INFO: `Contact info`,
    SELECT_SHIFT: `Select`,
    SHIFT_SELECTED: `Selected`,
    REFUSED_DESCRIPTION: `Selecting this result type will remove the user from any accepted shifts and make the previously accepted shifts available to other users.`,
    STATUS: {
      LABEL: `Event type`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Used to indicate the context of the event.`
    },

    ANSWER: {
      LABEL: `Result`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Used to indicate the result of the event.`
    },
    COMMENT: {
      LABEL: `Comment`,
      PLACEHOLDER: `Add a descriptive comment`,
      DESCRIPTION: `Used to add more information to the history entry, this field is required when event type view notes is selected.`
    }
  },
  CONTACT_LIST_SETTINGS_MODAL: {
    TITLE: `Edit list settings`,
    SUMMARY: `Used to change how a list is managed by the system.`,
    MAXACTIVECALLS: {
      LABEL: `Maximum number of active calls`,
      PLACEHOLDER: `Please enter a number higher than 0`,
      DESCRIPTION: `This maximum limits how many active calls the system can make in this list. If this number is higher than the number of waiting calls, the lower number will be used to prevent the system from exceeding the maximum number of waiting calls.`
    },
    MAXCONCURRENTCALLS: {
      LABEL: `Maximum number of waiting calls`,
      PLACEHOLDER: `Please enter a number higher than 0`,
      DESCRIPTION: `This maximum limits how many users can have an active delay.`
    },
    ACTIVATECONCURRENTCALLSRATIO: {
      LABEL: `Activate ratio for maximum number of waiting calls`,
      DESCRIPTION: `This ratio is used to determine how many calls can be waiting with an active delay based on how many shifts are remaining.`
    },
    CONCURRENTCALLSRATIO: {
      LABEL: `Maximum number of waiting calls ratio`,
      PLACEHOLDER: `Please enter a number higher than 0`,
      DESCRIPTION: `Fractional ratios are valid as an entry.`
    }
  },
  START_CONTACT_LIST_CONFIRMATION_MODAL: {
    TITLE: `Start the contact list`,
    SUMMARY: `Are you sure you want to start the contact list? eligible employees will start to receive calls.`
  },
  CREATE_LIST_MODAL: {
    TITLE: `Create contact list`,
    SUMMARY: `This allows for the quick distribution of shifts to eligible users.`,
    ERROR_LOADING: `Shifts not found`,
    ERROR_NO_VALID_EVENTS: `No valid shifts selected, make sure at least one of the shifts was not already in a contact list.`,
    ERROR_NO_AVAILABLE_CONFIGS: `No available list configurations, ask your administrator to set them up.`,
    ERROR_CREATING_LIST: `There was an error while creating the list, please try again.`,
    NOT_ALL_SAME_DAY: `Not all shifts selected were on the same day, they have been filtered out.`,
    NOT_ALL_OUT_OF_LIST: `Some shifts selected were already in a contact list, they have been filtered out.`,
    LISTCONFIGID: {
      LABEL: `Configuration to use`,
      DESCRIPTION: `Used to determine who is eligible for the shifts and what order they should be sorted in.`
    },
    SHOULDMERGE: {
      LABEL: `Merge with existing list`,
      DESCRIPTION: `Used to determine whether to create a new list or add shifts to an existing list on the same day.`
    },
    MERGEWITH: {
      LABEL: `List to merge with`,
      DESCRIPTION: `Used to select which list to merge with.`
    },
    ADDOTHERSHIFTS: {
      LABEL: `Add other unassigned shifts, attendances and timeOffs of the day to the list.`,
      DESCRIPTION: ``
    }
  },
  LIST_HISTORY: {
    ARCHIVED_LIST: `<0>{{ name }}</0> archived the list at <1>{{ time }}</1> on {{ date }}.`,
    PAUSED_LIST: `<0>{{ name }}</0> paused the list at <1>{{ time }}</1> on {{ date }}.`,
    STARTED_LIST: `<0>{{ name }}</0> started the list at <1>{{ time }}</1> on {{ date }}.`,
    RESUMED_LIST: `<0>{{ name }}</0> resumed the list at <1>{{ time }}</1> on {{ date }}.`,
    APPROVED_LIST: `<0>{{ name }}</0> changed list approval at <1>{{ time }}</1> on {{ date }}.`,
    APPROVED_SHIFT: `<0>{{ name }}</0> changed shift approval at <1>{{ time }}</1> on {{ date }}.`,
    MERGED_SHIFTS: `<0>{{ name }}</0> merged shifts into list <1>{{ time }}</1> on {{ date }}.`,
    ADDED_CONTACT_TEMPLATE: `<0>{{ name }}</0> added a contact template at <1>{{ time }}</1> on {{ date }}.`,
    REMOVED_CONTACT_TEMPLATE: `<0>{{ name }}</0> removed a contact template at <1>{{ time }}</1> on {{ date }}.`
  },
  HISTORY: {
    BY: `by`,
    'IN-PROGRESS': `In progress`,
    COMPLETE_IN_PERSON: `Completed in person`,
    COMPLETE_OVER_PHONE: `Completed over the phone`,
    OTHER_NOTES: `Other, See notes`,
    SET_MANUALLY: `Set manually`,
    BACKUP_CALL_SCHEDULED: `Backup call scheduled`,
    NO_DELAY: `No delay`,
    NOTE: `Note`,
    BUSY: `Busy`,
    ACCEPTED: `Accepted`,
    REFUSED: `Refused`,
    LEFT_MESSAGE: `Left message`,
    OTHER_PERSON_ACCEPTED: `Other person accepted`,
    OTHER_PERSON_REFUSED: `Other person refused`,
    OTHER_PERSON_LEFT_MESSAGE: `Left message with other person`,
    NO_ANSWER: `No answer`,
    NO_SERVICE: `No service`,
    NOT_AVAILABLE_ACCEPTED: `No shifts available`,
    NOT_AVAILABLE_REFUSED: `No shifts available`,
    CONTACTED_BY_MISTAKE: `Contacted by mistake`,
    BUMPED: `Bumped`,
    SHOULD_CALL: `Should call`,
    SHOULD_NOT_CALL: `should not call`,
    CHANGED_PRIORITY: `Changed priority`,
    CHANGED_NUMBER_OF_TIMES_CONTACTED: `Changed number of times contacted`,
    CHANGED_NUMBER_OF_HOURS_OFFERED: `Changed number of hours offered`,
    NO_SHIFTS_TO_OFFER: `No shifts to offer`,
    NO_PHONE_NUMBER: `No phone number`,
    NO_PUSH_NOTIFICATIONS: `Push notifications disabled`,
    DID_NOT_CALL_BACK: `Did not call back within delay`,
    USER_ARCHIVED: `Is archived`,
    WAITING: `Waiting`,
    COMPLETED: `Completed`,
    ALREADY_ACCEPTED: `Already accepted`,
    CALLED_BACK: `Called back`,
    TEXTED_BACK: `Texted back`,
    NOT_CALLED: `Not called or texted`,
    NOT_CONTACTED: `Not contacted`,
    CALL_STARTED: `Call started`,
    CHECKED_MESSAGES_APP: `Checked messages in app`,
    RINGING: `Ringing`,
    IN_PROGRESS: `In progress`,
    FAILED: `Failed`,
    PUSH_NOTIFICATION_SENT: `Push notification sent`,
    TEXT_MESSAGE_SENT: `Text message sent`,
    TEXT_MESSAGE_DELIVERED: `Text message delivered`,
    TEXT_MESSAGE_UNDELIVERED: `Text message undelivered`,
    TEXT_MESSAGE_SENDING: `Text message sending`,
    TEXT_MESSAGE_FAILED: `Text message failed`,
    HUNG_UP: `Hung up`,
    HUNG_UP_AGAIN: `Hung up again`,
    CALLING_OTHER_NUMBER: `Calling other number`,
    CALL_DURATION: `Call duration`,
    MERGED_LIST: `Shift offers updated after merged shifts into the list`,
    MERGED_LIST_WITH_SHIFTS: `Adding new shift`,
    MERGED_LIST_NO_SHIFTS: `No shift to add`,
    undefined: `NA`
  },
  ARCHIVE_BUTTON: {
    TITLE: `Archive the contact list`,
    SUMMARY: `This will permanently archive the contact list. The info contained within it will still be available to consult.`,
    USERNAME_REQUIRED: `Enter your username to continue`,
    PRIMARY_ACTION: `Archive the contact list`,
    USERNAME: {
      LABEL: `Username`,
      PLACEHOLDER: `Enter your username for validation`,
      DESCRIPTION: ``
    }
  },
  DELETE_BUTTON: {
    TITLE: `Delete the contact list`,
    SUMMARY: `Are you sure you want to delete this contact list?`,
    PRIMARY_ACTION: `Delete the contact list`
  },
  WORKING_TODAY: `Is working today ({{ shifts }})`,
  ON_TIME_OFF: `Is on time off today ({{timeOffs}})`,
  ON_LEAVE: `Is on leave today ({{attendances}})`,
  ALL_DAY_LONG: `All day long`,
  STARTING_AT: `Starting at {{start}}`,
  ENDING_AT: `Until {{end}}`,
  TAKEN_BY: `Taken by {{ takenBy }}`,
  NO_USERS_ELIGIBLE: `No users eligible`,
  USERS_ELIGIBLE: `{{ count }} user eligible `,
  USERS_ELIGIBLE_other: `{{ count }} users eligible`,
  IS_AVAILABLE: `Is available`,
  IS_NOT_AVAILABLE: `Not available`,
  MAKE_NOT_AVAILABLE: `Make unavailable`,
  MAKE_AVAILABLE: `Make available`,
  NOT_CONTACTED_YET: `Not contacted yet`,
  NOT_ELIGIBLE: `Not eligible`,
  ELIGIBLE_FOR_UNAPPROVED_SHIFTS: `Eligible for unapproved shifts`,
  CALLBACK_DELAY: `has {{ delay }} to call back`,
  OPTIONS: `Options`,
  ADD_HISTORY_EVENT: `Add history event`,
  MARK_SHOULD_NOT_CALL: `Mark as should not call`,
  MARK_SHOULD_CALL: `Mark as should call`,
  CHANGE_PRIORITY: `Change priority`,
  PAUSE_LIST_AT_THIS_USER: `Pause list here`,
  UNPAUSE_LIST_AT_THIS_USER: `Don't pause list here`,
  PAUSE_LIST_AT_THIS_USER_DESCRIPTION: `List will pause before this employee`,
  ADJUST_NUMBER_OF_TIMES_CONTACTED: `Adjust number of times contacted`,
  ADJUST_NUMBER_OF_HOURS_OFFERED: `Adjust number of hours offered`,
  VIEW_HISTORY: `View history`,
  VIEW_SHIFT_ELIGIBILITY: `View shift eligibility`,
  SUMMARY: `Summary`,
  STATUS: `Status`,
  CREATIONDATE: `Creation date`,
  SHIFTS: `Shifts`,
  ACTIVE_CALLS: `Active calls`,
  CONCURRENT_CALLS: `Concurrent calls`,
  GROUPED_LIST: `Grouped list`,
  ACTIVE_CALLS_SUMMARY: `{{ count }} active call out of a maximum of {{ maxActiveCalls }}`,
  ACTIVE_CALLS_SUMMARY_other: `{{ count }} active calls out of a maximum of {{ maxActiveCalls }}`,
  CONCURRENT_CALLS_SUMMARY: `{{ count }} concurrent call out of a maximum of {{ maxConcurrentCalls }}`,
  CONCURRENT_CALLS_SUMMARY_other: `{{ count }} concurrent calls out of a maximum of {{ maxConcurrentCalls }}`,
  START: `Start`,
  RESUME: `Resume`,
  PAUSE: `Pause`,
  ARCHIVE: `Archive`,
  DELETE: `Delete`,
  SEE_HISTORY: `See list history`,
  REPORT_PDF: `Export the list as PDF`,
  REPORT_CSV: `Export the list as CSV`,
  SETTINGS: `List settings`,
  NUMBER_OF_TIMES_CONTACTED: `Has been contacted {{ count }} time in this type of list.`,
  NUMBER_OF_TIMES_CONTACTED_other: `Has been contacted {{ count }} times in this type of list.`,
  NUMBER_OF_HOURS_OFFERED: `Has been offered {{ count }} hour in this type of list.`,
  NUMBER_OF_HOURS_OFFERED_other: `Has been offered {{ count }} hours in this type of list.`,
  ALL_SHIFTS_DELETED: `All of the shifts in the list have been deleted.`,
  NOTIFICATIONS: `Notifications`,
  DELETE_NOTIFICATION_TEMPLATE: `Delete template`,
  EDIT_NOTIFICATION_TEMPLATE: {
    TITLE: `Edit a notification template`,
    SUMMARY: `Notification templates allow you to quickly select a group of users to receive notifications for a contact list.`
  },
  CREATE_NOTIFICATION_TEMPLATE: {
    TITLE: `Create a notification template`,
    SUMMARY: `Notification templates allow you to quickly select a group of users to receive notifications for a contact list.`
  },
  SHIFTSLIST: `{{ count }}/{{totalShifts}} filled shift.`,
  SHIFTSLIST_other: `{{ count }}/{{totalShifts}} filled shifts.`,

  notificationTemplate: {
    SELECT_USER_TO_ADD_CONTACTS: `Select a user to add them to the contacts`,
    NAME_MANDATORY: `You must enter a name.`,
    ACTIVATE_TEMPLATES: `Activate a template`,
    ACTIVATE_TEMPLATE: `Activate <0>{{ name }}</0>`,
    DISABLE_TEMPLATE: `Disable <0>{{ name }}</0>`,
    CREATE_NEW_TEMPLATE: `Create a new notification template`,
    MANAGE_TEMPLATES: `Manage notification templates`,
    EDIT_TEMPLATE: `Edit <0>{{ name }}</0>`,
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter a name`,
      DESCRIPTION: `The name will be used to recognize the notification template when selecting which one to activate.`
    },
    CONTACTS: {
      LABEL: `Contacts`,
      DESCRIPTION: `Used to determine who to send notifications to while the list is running.`
    },
    ISDEFAULT: {
      LABEL: `Is default`,
      DESCRIPTION: `This notification template will be active on all new lists.`
    }
  },
  export: {
    TITLE: `Contact list report`,
    GENERATED_BY: `Generated by`,
    CREATED_THE: `Created on`,
    FOR_THE: `For the`,
    BY: `By`,
    FIRSTNAME: `First name`,
    LASTNAME: `Last name`,
    POSITION: `Position`,
    START: `Start`,
    END: `End`,
    DATE: `Date`,
    ELIGIBLE: `Eligible`,
    TAKEN_BY: `Taken by`,
    ANSWER: `Answer`,
    STATUS: `Status`,
    REASON: `Reason`,
    COMMENT: `Comment`,
    DONE_BY: `Done by`,
    TIME: `Time`,
    FILE_NAME: `contact_list_report_{{ dates }}`,
    EMPLOYEE: `Employee`,
    EMPLOYEENUMBER: `Employee number`,
    NUMBEROFHOURSOFFERED: `Number of hours offered`,
    NUMBEROFTIMESCONTACTED: `Number of times contacted`,
    TOTALNUMBEROFHOURSEOFFERED: `Total number of hours offered`,
    TOTALNUMBEROFTIMESCONTACTED: `Total number of times contacted`,
    CALL_DURATION: `Call duration`,
    CSV_FILE_NAME: `contact_list_users_history_{{shortListId}}`
  },
  EVENT_SUMMARY: `<0>{{ positionName }}</0> <1>{{ start }} - {{ end }})</1>`,
  SEE_CONTACT_HISTORY_THIS_PAGE: `See users history for this page`,
  SEE_CONTACT_HISTORY: `See users history for current filter`,
  EXPORT_CONTACT_HISTORY_THIS_PAGE: `Export user history for current page (CSV)`,
  EXPORT_CONTACT_HISTORY: `Export user history for current filter (CSV)`,
  TWILIO_NOT_OPERATIONAL: `There seems to be an issue with our call and sms provider, this may affect contact lists and notifications. Contact our support if you need to run a contact list to make sure it will not be affected.`,
  LIST_NOT_FINISHED_CREATING: `This list is still being created. This can take a couple of minutes, the page will refresh automatically when it is done.`,
  LIST_UNAPPROVED: `This list is not approved yet. It won't start until it is approved.`
}
